import React from 'react';

import MessageInputContextProvider from './MessageInputContextProvider';

const withMessageInputContextProvider = (Component) => (props) => (
  <MessageInputContextProvider>
    <Component {...props} />
  </MessageInputContextProvider>
);

export {
  withMessageInputContextProvider,
};
